import { getLocaleDateFormat } from '@angular/common';
import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CodePanneOccurrence } from 'src/app/model/breakdowns/breakdown';
import { CallStat, CodePanne, ContractType } from 'src/app/model/call/call.model';
import { Action, Intervenant, TypeAppel } from 'src/app/model/gestion/gestion';
import { InstallContract } from 'src/app/model/installation/installation.model';
import { CallService } from 'src/app/services/http/call/call.service';
import { GestionActionsSavService } from 'src/app/services/http/gestion/gestion-actions-sav.service';
import { GestionIntervenantsSavService } from 'src/app/services/http/gestion/gestion-intervenants-sav.service';
import { GestionTypesAppelsService } from 'src/app/services/http/gestion/gestion-types-appels.service';
import { UtilsService } from 'src/app/services/tools/utils.service';

@Component({
  selector: 'app-search-contracts',
  templateUrl: './search-contracts.component.html',
  styleUrls: ['./search-contracts.component.scss']
})
export class SearchContractsComponent implements OnInit {


  get displayedColumnInstall(): string[] {
    const result: string[] = ['numSerie', 'nom', 'contrat', 'dateDebut', 'dateFin', 'mail', 'cp'];
    return result;
  }


  constructor(private service: CallService,
    private builder: FormBuilder,
    private utils: UtilsService,
    private appelsSavService: GestionTypesAppelsService,
    private actionsSavService: GestionActionsSavService,
    private intervenantsSavService: GestionIntervenantsSavService,
    private router: Router) { }

  /**
   * Boolean indicating if spinner has to be shown while something is being loaded
   */
  public isLoading: boolean = false;

  /** Types of contracts */
  typesContrat!: ContractType[];

  /**
   * List of contracts found
   */
  installContracts!: InstallContract[];

  /**
   * Search Form installations contracts
   */
  searchInstallForm!: FormGroup;

  /**
   * Value selected by user in the mat select
   */
  selectedValue : string ='';

  ngOnInit(): void {


    /** Load the contracts types available */
    this.service.getContractsTypes().subscribe((contracts) => {
      this.typesContrat = contracts;
    });



    this.searchInstallForm = this.builder.group({
      contractTypeInstall: [''],
      operatorDebut: [''],
      startDateContract: [''],
      operatorFin: [''],
      endDateContract1: [''],
      endDateContract2:['']
    }
    );

  }

  onChange(newValue:any) {
    this.selectedValue = newValue;

    if ( this.selectedValue != "entre" ) {
      this.searchInstallForm.controls.endDateContract2.setValue("");
    }
  }

  onSubmitInstall() {
    this.isLoading = true;
    // Since issue 53 - get contract dates and type 
    // /installcontractslist/?contractType=1&paramStart=<startDate=startDate&paramEnd=>&endDate=endDate
    // contractTypeInstall
    // operatorDebut
    // startDateContract
    // operatorFin
    // endDateContract

    this.service.getInstallListByContract(this.searchInstallForm.controls.contractTypeInstall.value,
      this.searchInstallForm.controls.operatorDebut.value,
      this.searchInstallForm.controls.startDateContract.value,
      this.searchInstallForm.controls.operatorFin.value,
      this.searchInstallForm.controls.endDateContract1.value,
      this.searchInstallForm.controls.endDateContract2.value
    ).subscribe((installs) => {
      this.installContracts = installs;
      this.isLoading = false;
    });
  }



  public getNiceDate(date: string) {
    return this.utils.getNiceDate(date);
  }



}
